import { render, staticRenderFns } from "./ChatEdit.vue?vue&type=template&id=9dd24190&scoped=true&lang=pug&"
import script from "./ChatEdit.vue?vue&type=script&lang=js&"
export * from "./ChatEdit.vue?vue&type=script&lang=js&"
import style0 from "./ChatEdit.vue?vue&type=style&index=0&id=9dd24190&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd24190",
  null
  
)

export default component.exports